import React from 'react'
import moment from 'moment'
import _ from 'lodash'
import * as request from 'superagent'
import { hashHistory } from 'react-router'
import { getToken } from '../Commons/Authentication'
import calculate from '../Dashboard/MedicalCalculate'
import PatientData from './PatientData'
import MedicalData from './MedicalData'
import DiabetesData from './DiabetesData'
import SicorLogoColor from '../../img/logos/color_logo.png'
import MiddleLine from '../../img/icons/general-icons/separator_icon_gray.png'

export default class PrintableDiabetes extends React.Component {
  constructor (props) {
    super(props)
    document.body.style.color = 'black'
    document.body.style.height = '100%'
    document.body.style.minHeight = '960px'
    document.body.style.overflowX = 'hidden'
    document.body.style.background = 'white'

    this.state = ({
      data: {
        patientData: {},
        patientAge: '',
        patientEPS: '',
        patientIMC: '',
        medicalData: {},
        diabetesData: {},
        diabetesCalc: {},
        albuminuria: '',
        percent_lost_capacity: 0,
        fx_reserve: 0,
        vitalityIndex: 0,
        functionalIndex: 0,
        balanceAfectivo: '',
        arterialAge: 0,
        biologicalAge: 0,
        reportTitle: '',
        IMCRange: '',
        perAbdRange: '',
        presArRange: '',
        vopRange: '',
        fcRange: '',
        itbiRange: '',
        itbdRange: '',
        coltRange: '',
        trigRange: '',
        collRange: '',
        colhRange: '',
        hba1cRange: '',
        albuRange: '',
        creatRange: '',
        gliceRange: '',
        balIzRange: '',
        balDeRange: '',
        indViRange: '',
        indCaRange: '',
        resFnRange: '',
        balAfRange: '',
        edadARange: '',
        edadBRange: '',
        ojosERange: '',
        rinonRange: '',
        neuroRange: '',
        metabRange: '',
        corazRange: '',
        cerebRange: '',
        vascuRange: '',
        hospiRange: '',
        superRange: '',
        duraDRange: '',
        tabaqRange: '',
        iamSERange: '',
        iccSERange: '',
        acvSERange: '',
        angSERange: '',
        iamCERange: '',
        iccCERange: '',
        acvCERange: '',
        angCERange: '',
        clasFRange: '',
        clasSRange: '',
        feviVRange: '',
        evaPDRange: ''
      }
    })
  }

  componentWillMount () {
    this.findPatientData()
  }

  findPatientData () {
    let identificacion = this.props.params.patient
    request
      .get('api/v1/patient/find?numeroDocumento=' + identificacion)
      .set('Authorization', 'Bearer ' + getToken())
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err || !res.ok) {
          console.log('Error: ', err, 'And respo: ', res)
        } else {
          let result = res.body[0]
          var birthday = new Date(result.fechaNacimiento.split('/').reverse().join('-'))
          var ageDifMs = Date.now() - birthday.getTime()
          var ageDate = new Date(ageDifMs)
          var age = Math.abs(ageDate.getUTCFullYear() - 1970)
          var eps = result.eps[0].nombre
          console.log(eps)
          var newData = this.state.data
          newData.patientData = result
          newData.patientAge = age
          newData.patientEPS = eps

          var title = ''
          if (newData.patientData.diabetico === true) {
            title = 'Evaluación del estado de salud y riesgos'
          } else {
            title = 'Evaluación del estado de salud y riesgos'
          }

          this.setState({ data: newData, reportTitle: title })
          this.findDiabetes(result.id)
          this.findMedicalPatient(result._id)
        }


      })
  }

  findMedicalPatient (id) {
    request
      .get(`api/v1/estadoSalud/paciente/${id}/ultimoEstadoSalud`)
      .set('Authorization', 'Bearer ' + getToken())
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err || !res.ok) {
          console.log('Error: ', err)
        } else {

          let result = res.body
          var altura = result.altura / 100
          var indice = Math.floor(result.peso / (altura * altura))

          var newData = this.state.data
          newData.medicalData = result

          newData.patientIMC = indice

          this.setState({ data: newData })
        }
        this.medicalCalculate()
      })
  }

  checkRangesClass () {
    var newData = this.state.data
    
    var presionArterialAlta = (parseFloat(this.state.data.medicalData.sistoleParado) + parseFloat(this.state.data.medicalData.sistoleSentado)) / 2
    var presionArterialBaja = (this.state.data.medicalData.diastoleParado + this.state.data.medicalData.diastoleSentado) / 2
    var balancePerAge = [ [18, 40, 50, 60, 70, 80, 90, 100], [45, 42, 42, 32, 22, 10, 10, 10] ]
    var balanceExpected = this.vlookup(this.state.data.patientAge, balancePerAge)
    var difAretrial = this.state.data.arterialAge - this.state.data.patientAge
    var difBiologica = this.state.data.biologicalAge - this.state.data.patientAge
  console.log(this.state.data.medicalData)
    if ((this.state.data.medicalData.imc >= 20) && (this.state.data.medicalData.imc < 25)) {
      newData.IMCRange = 'good-range'
      this.setState({ data: newData })
    } else if ((this.state.data.medicalData.imc >= 25) && (this.state.data.medicalData.imc < 30)) {
      newData.IMCRange = 'regular-range'
      this.setState({ data: newData })
    } else if ((this.state.data.medicalData.imc < 20) || (this.state.data.medicalData.imc >= 30)) {
      newData.IMCRange = 'bad-range'
      this.setState({ data: newData })
    }

    if ((this.state.data.patientData.genero === 'm') && (this.state.data.medicalData.perimetroAbdominal <= 94)) {
      newData.perAbdRange = 'good-range'
      this.setState({ data: newData })
    } else if ((this.state.data.patientData.genero === 'm') && (this.state.data.medicalData.perimetroAbdominal > 94)) {
      newData.perAbdRange = 'bad-range'
      this.setState({ data: newData })
    }

    if ((this.state.data.patientData.genero === 'f') && (this.state.data.medicalData.perimetroAbdominal <= 82)) {
      newData.perAbdRange = 'good-range'
      this.setState({ data: newData })
    } else if ((this.state.data.patientData.genero === 'f') && (this.state.data.medicalData.perimetroAbdominal > 82)) {
      newData.perAbdRange = 'bad-range'
      this.setState({ data: newData })
    }

    if ((presionArterialAlta < 120) && (presionArterialBaja < 80)) {
      newData.presArRange = 'good-range'
      this.setState({ data: newData })
    } else if ((presionArterialAlta > 140) || (presionArterialBaja > 90)) {
      newData.presArRange = 'bad-range'
      this.setState({ data: newData })
    } else if (((presionArterialAlta >= 120) && (presionArterialAlta <= 139)) || ((presionArterialBaja >= 80) && (presionArterialBaja <= 89))) {
      newData.presArRange = 'regular-range'
      this.setState({ data: newData })
    }

    if (this.state.data.medicalData.vop < 10) {
      newData.vopRange = 'good-range'
      this.setState({ data: newData })
    } else if (this.state.data.medicalData.vop >= 10) {
      newData.vopRange = 'bad-range'
      this.setState({ data: newData })
    }

    if ((this.state.data.medicalData.frecuencia < 50) || this.state.data.medicalData.frecuencia >= 90) {
      newData.fcRange = 'bad-range'
      this.setState({ data: newData })
    } else if ((this.state.data.medicalData.frecuencia >= 50) && (this.state.data.medicalData.frecuencia <= 89)) {
      newData.fcRange = 'good-range'
      this.setState({ data: newData })
    }

    if ((this.state.data.medicalData.itbIzquierdo < 0.9) || (this.state.data.medicalData.itbIzquierdo > 1.2)) {
      newData.itbiRange = 'bad-range'
      this.setState({ data: newData })
    } else if ((this.state.data.medicalData.itbIzquierdo >= 0.9) || (this.state.data.medicalData.itbIzquierdo <= 1.2)) {
      newData.itbiRange = 'good-range'
      this.setState({ data: newData })
    }

    if ((this.state.data.medicalData.itbDerecho < 0.9) || (this.state.data.medicalData.itbDerecho > 1.2)) {
      newData.itbdRange = 'bad-range'
      this.setState({ data: newData })
    } else if ((this.state.data.medicalData.itbDerecho >= 0.9) || (this.state.data.medicalData.itbDerecho <= 1.2)) {
      newData.itbdRange = 'good-range'
      this.setState({ data: newData })
    }

    if (this.state.data.medicalData.colesterolTotal < 200) {
      newData.coltRange = 'good-range'
      this.setState({ data: newData })
    } else if ((this.state.data.medicalData.colesterolTotal >= 200) && (this.state.data.medicalData.colesterolTotal <= 270)) {
      newData.coltRange = 'regular-range'
      this.setState({ data: newData })
    } else if (this.state.data.medicalData.colesterolTotal > 270) {
      newData.coltRange = 'bad-range'
      this.setState({ data: newData })
    }

    if (this.state.data.medicalData.trigliceridos < 150) {
      newData.trigRange = 'good-range'
      this.setState({ data: newData })
    } else if ((this.state.data.medicalData.trigliceridos >= 150) && (this.state.data.medicalData.trigliceridos <= 300)) {
      newData.trigRange = 'regular-range'
      this.setState({ data: newData })
    } else if (this.state.data.medicalData.trigliceridos > 300) {
      newData.trigRange = 'bad-range'
      this.setState({ data: newData })
    }

    if (this.state.data.medicalData.colesterolLDL < 100) {
      newData.collRange = 'good-range'
      this.setState({ data: newData })
    } else if ((this.state.data.medicalData.colesterolLDL >= 100) && (this.state.data.medicalData.colesterolLDL <= 190)) {
      newData.collRange = 'regular-range'
      this.setState({ data: newData })
    } else if (this.state.data.medicalData.colesterolLDL > 190) {
      newData.collRange = 'bad-range'
      this.setState({ data: newData })
    }

    if (this.state.data.medicalData.colesterolHDL < 40) {
      newData.colhRange = 'bad-range'
      this.setState({ data: newData })
    } else if ((this.state.data.medicalData.colesterolHDL >= 40) && (this.state.data.medicalData.colesterolHDL <= 60)) {
      newData.colhRange = 'regular-range'
      this.setState({ data: newData })
    } else if (this.state.data.medicalData.colesterolHDL > 60) {
      newData.colhRange = 'good-range'
      this.setState({ data: newData })
    }

    if (this.state.data.medicalData.creatinina < 1.2) {
      newData.creatRange = 'good-range'
      this.setState({ data: newData })
    } else if ((this.state.data.medicalData.creatinina >= 1.2) && (this.state.data.medicalData.creatinina <= 1.5)) {
      newData.creatRange = 'regular-range'
      this.setState({ data: newData })
    } else if (this.state.data.medicalData.creatinina > 1.5) {
      newData.creatRange = 'bad-range'
      this.setState({ data: newData })
    }

    if (this.state.data.medicalData.glicemia <= 100) {
      newData.gliceRange = 'good-range'
      this.setState({ data: newData })
    } else if ((this.state.data.medicalData.glicemia >= 101) && (this.state.data.medicalData.glicemia <= 126)) {
      newData.gliceRange = 'regular-range'
      this.setState({ data: newData })
    } else if (this.state.data.medicalData.glicemia > 126) {
      newData.gliceRange = 'bad-range'
      this.setState({ data: newData })
    }

    if (this.state.data.albuminuria === 0) {
      newData.albuRange = 'bad-range'
      this.setState({ data: newData })
    } else if (this.state.data.albuminuria === 1) {
      newData.albuRange = 'good-range'
      this.setState({ data: newData })
    }

    if (this.state.data.diabetesData.hba1c < 5.5) {
      newData.hba1cRange = 'good-range'
      this.setState({ data: newData })
    } else if ((this.state.data.diabetesData.hba1c >= 5.5) && (this.state.data.diabetesData.hba1c < 6.5)) {
      newData.hba1cRange = 'regular-range'
      this.setState({ data: newData })
    } else if ((this.state.data.diabetesData.hba1c >= 6.5) && (this.state.data.diabetesData.hba1c <= 8.5)) {
      newData.hba1cRange = 'orange-range'
      this.setState({ data: newData })
    } else if (this.state.data.diabetesData.hba1c > 8.5) {
      newData.hba1cRange = 'bad-range'
      this.setState({ data: newData })
    }

    if (this.state.data.medicalData.balanceNeuroMuscularIzquierdo < balanceExpected) {
      newData.balIzRange = 'bad-range'
      this.setState({ data: newData })
    } else if (this.state.data.medicalData.balanceNeuroMuscularIzquierdo >= balanceExpected) {
      newData.balIzRange = 'good-range'
      this.setState({ data: newData })
    }

    if (this.state.data.medicalData.balanceNeuroMuscularDerecho < balanceExpected) {
      newData.balDeRange = 'bad-range'
      this.setState({ data: newData })
    } else if (this.state.data.medicalData.balanceNeuroMuscularIzquierdo >= balanceExpected) {
      newData.balDeRange = 'good-range'
      this.setState({ data: newData })
    }

    if (this.state.data.vitalityIndex < 7) {
      newData.indViRange = 'bad-range'
      this.setState({ data: newData })
    } else if (this.state.data.vitalityIndex >= 7) {
      newData.indViRange = 'good-range'
      this.setState({ data: newData })
    }

    if (this.state.data.functionalIndex < 8) {
      newData.indCaRange = 'bad-range'
      this.setState({ data: newData })
    } else if (this.state.data.functionalIndex >= 8) {
      newData.indCaRange = 'good-range'
      this.setState({ data: newData })
    }

    if (this.state.data.balanceAfectivo < 60) {
      newData.balAfRange = 'bad-range'
      this.setState({ data: newData })
    } else if (this.state.data.balanceAfectivo >= 60) {
      newData.balAfRange = 'good-range'
      this.setState({ data: newData })
    }

    if (difAretrial < 6) {
      newData.edadARange = 'good-range'
      this.setState({ data: newData })
    } else if (difAretrial >= 6) {
      newData.edadARange = 'bad-range'
      this.setState({ data: newData })
    }

    if (difBiologica < 6) {
      newData.edadBRange = 'good-range'
      this.setState({ data: newData })
    } else if (difBiologica >= 6) {
      newData.edadBRange = 'bad-range'
      this.setState({ data: newData })
    }

    if (this.state.data.diabetesData.ojos === 0) {
      newData.ojosERange = 'good-range'
      this.setState({ data: newData })
    } else {
      newData.ojosERange = 'bad-range'
      this.setState({ data: newData })
    }

    if (this.state.data.diabetesData.rinon === 0) {
      newData.rinonRange = 'good-range'
      this.setState({ data: newData })
    } else {
      newData.rinonRange = 'bad-range'
      this.setState({ data: newData })
    }

    if (this.state.data.diabetesData.neuropatia === 0) {
      newData.neuroRange = 'good-range'
      this.setState({ data: newData })
    } else {
      newData.neuroRange = 'bad-range'
      this.setState({ data: newData })
    }

    if (this.state.data.diabetesData.cerebroVascular === 0) {
      newData.cerebRange = 'good-range'
      this.setState({ data: newData })
    } else {
      newData.cerebRange = 'bad-range'
      this.setState({ data: newData })
    }

    if (this.state.data.diabetesData.corazon === 0) {
      newData.corazRange = 'good-range'
      this.setState({ data: newData })
    } else {
      newData.corazRange = 'bad-range'
      this.setState({ data: newData })
    }

    if (this.state.data.diabetesData.metabolico === 0) {
      newData.metabRange = 'good-range'
      this.setState({ data: newData })
    } else {
      newData.metabRange = 'bad-range'
      this.setState({ data: newData })
    }

    if (this.state.data.diabetesData.vascularPeriferico === 0) {
      newData.vascuRange = 'good-range'
      this.setState({ data: newData })
    } else {
      newData.vascuRange = 'bad-range'
      this.setState({ data: newData })
    }

    if (this.state.data.diabetesCalc.riesgoHospitalizacion < 10) {
      newData.hospiRange = 'good-range'
      this.setState({ data: newData })
    } else if ((this.state.data.diabetesCalc.riesgoHospitalizacion >= 10) && (this.state.data.diabetesCalc.riesgoHospitalizacion <= 30)) {
      newData.hospiRange = 'orange-range'
      this.setState({ data: newData })
    } else if (this.state.data.diabetesCalc.riesgoHospitalizacion > 30) {
      newData.hospiRange = 'bad-range'
      this.setState({ data: newData })
    }

    if (this.state.data.diabetesCalc.supervivenciaAlAño > 90) {
      newData.superRange = 'good-range'
      this.setState({ data: newData })
    } else if ((this.state.data.diabetesCalc.supervivenciaAlAño <= 90) && (this.state.data.diabetesCalc.supervivenciaAlAño >= 60)) {
      newData.superRange = 'orange-range'
      this.setState({ data: newData })
    } else if (this.state.data.diabetesCalc.supervivenciaAlAño < 60) {
      newData.superRange = 'bad-range'
      this.setState({ data: newData })
    }

    if (this.state.data.diabetesData.duracionDm < 10) {
      newData.duraDRange = 'good-range'
      this.setState({ data: newData })
    } else if (this.state.data.diabetesData.duracionDm > 20){
      newData.duraDRange = 'bad-range'
      this.setState({ data: newData })
    } else {
      newData.duraDRange = 'orange-range'
      this.setState({ data: newData })
    }

    if (this.state.data.medicalData.fuma === 'No') {
      newData.tabaqRange = 'good-range'
      this.setState({ data: newData })
    } else {
      newData.tabaqRange = 'bad-range'
      this.setState({ data: newData })
    }

    if (this.state.data.diabetesCalc.riesgoIcc <= 20) {
      newData.iccSERange = 'regular-range'
      this.setState({ data: newData })
    } else if ((this.state.data.diabetesCalc.riesgoIcc > 20) && (this.state.data.diabetesCalc.riesgoIcc <= 40)) {
      newData.iccSERange = 'orange-range'
      this.setState({ data: newData })
    } else if (this.state.data.diabetesCalc.riesgoIcc > 40) {
      newData.iccSERange = 'bad-range'
      this.setState({ data: newData })
    }

    if (this.state.data.diabetesCalc.riesgoReeventoIcc <= 20) {
      newData.iccCERange = 'regular-range'
      this.setState({ data: newData })
    } else if ((this.state.data.diabetesCalc.riesgoReeventoIcc > 20) && (this.state.data.diabetesCalc.riesgoReeventoIcc <= 40)) {
      newData.iccCERange = 'orange-range'
      this.setState({ data: newData })
    } else if (this.state.data.diabetesCalc.riesgoReeventoIcc > 40) {
      newData.iccCERange = 'bad-range'
      this.setState({ data: newData })
    }

    if (this.state.data.diabetesCalc.riesgoIm <= 20) {
      newData.iamSERange = 'regular-range'
      this.setState({ data: newData })
    } else if ((this.state.data.diabetesCalc.riesgoIm > 20) && (this.state.data.diabetesCalc.riesgoIm <= 40)) {
      newData.iamSERange = 'orange-range'
      this.setState({ data: newData })
    } else if (this.state.data.diabetesCalc.riesgoIm > 40) {
      newData.iamSERange = 'bad-range'
      this.setState({ data: newData })
    }

    if (this.state.data.diabetesCalc.riesgoReeventoIm <= 20) {
      newData.iamCERange = 'regular-range'
      this.setState({ data: newData })
    } else if ((this.state.data.diabetesCalc.riesgoReeventoIm > 20) && (this.state.data.diabetesCalc.riesgoReeventoIm <= 40)) {
      newData.iamCERange = 'orange-range'
      this.setState({ data: newData })
    } else if (this.state.data.diabetesCalc.riesgoReeventoIm > 40) {
      newData.iamCERange = 'bad-range'
      this.setState({ data: newData })
    }

    if (this.state.data.diabetesCalc.riesgoAcv <= 20) {
      newData.acvSERange = 'regular-range'
      this.setState({ data: newData })
    } else if ((this.state.data.diabetesCalc.riesgoAcv > 20) && (this.state.data.diabetesCalc.riesgoAcv <= 40)) {
      newData.acvSERange = 'orange-range'
      this.setState({ data: newData })
    } else if (this.state.data.diabetesCalc.riesgoAcv > 40) {
      newData.acvSERange = 'bad-range'
      this.setState({ data: newData })
    }

    if (this.state.data.diabetesCalc.riesgoReeventoAcv <= 20) {
      newData.acvCERange = 'regular-range'
      this.setState({ data: newData })
    } else if ((this.state.data.diabetesCalc.riesgoReeventoAcv > 20) && (this.state.data.diabetesCalc.riesgoReeventoAcv <= 40)) {
      newData.acvCERange = 'orange-range'
      this.setState({ data: newData })
    } else if (this.state.data.diabetesCalc.riesgoReeventoAcv > 40) {
      newData.acvCERange = 'bad-range'
      this.setState({ data: newData })
    }

    if (this.state.data.diabetesCalc.riesgoAnginaIsquemia <= 20) {
      newData.angSERange = 'regular-range'
      this.setState({ data: newData })
    } else if ((this.state.data.diabetesCalc.riesgoAnginaIsquemia > 20) && (this.state.data.diabetesCalc.riesgoAnginaIsquemia <= 40)) {
      newData.angSERange = 'orange-range'
      this.setState({ data: newData })
    } else if (this.state.data.diabetesCalc.riesgoAnginaIsquemia > 40) {
      newData.angSERange = 'bad-range'
      this.setState({ data: newData })
    }

    if (this.state.data.diabetesCalc.riesgoReeventoAnginaIsquemia <= 20) {
      newData.angCERange = 'regular-range'
      this.setState({ data: newData })
    } else if ((this.state.data.diabetesCalc.riesgoReeventoAnginaIsquemia > 20) && (this.state.data.diabetesCalc.riesgoReeventoAnginaIsquemia <= 40)) {
      newData.angCERange = 'orange-range'
      this.setState({ data: newData })
    } else if (this.state.data.diabetesCalc.riesgoReeventoAnginaIsquemia > 40) {
      newData.angCERange = 'bad-range'
      this.setState({ data: newData })
    }

    if (this.state.data.diabetesData.claseFuncional === 'I') {
      newData.clasFRange = 'good-range'
      this.setState({ data: newData })
    } else if (this.state.data.diabetesData.claseFuncional === 'II') {
      newData.clasFRange = 'regular-range'
      this.setState({ data: newData })
    } else if ((this.state.data.diabetesData.claseFuncional === 'III') || (this.state.data.diabetesData.claseFuncional === 'IV')) {
      newData.clasFRange = 'bad-range'
      this.setState({ data: newData })
    }

    if (this.state.data.diabetesData.clasificacionFase === '1') {
      newData.clasSRange = 'good-range'
      this.setState({ data: newData })
    } else if (this.state.data.diabetesData.clasificacionFase === '3B') {
      newData.clasSRange = 'bad-range'
      this.setState({ data: newData })
    } else if ((this.state.data.diabetesData.clasificacionFase === '2') || (this.state.data.diabetesData.clasificacionFase === '3A')) {
      newData.clasSRange = 'regular-range'
      this.setState({ data: newData })
    }
    // claseFuncional 3A
    // clasificacionFase I II III IV

    if (this.state.data.diabetesData.fevi < 30) {
      newData.feviVRange = 'bad-range'
      this.setState({ data: newData })
    } else if ((this.state.data.diabetesData.fevi >= 30) && (this.state.data.medicalData.fevi < 40)) {
      newData.feviVRange = 'orange-range'
      this.setState({ data: newData })
    } else if ((this.state.data.diabetesData.fevi >= 40) && (this.state.data.medicalData.fevi <= 50)) {
      newData.feviVRange = 'regular-range'
      this.setState({ data: newData })
    } else if (this.state.data.diabetesData.fevi > 50) {
      newData.feviVRange = 'good-range'
      this.setState({ data: newData })
    }

    if (this.state.data.diabetesData.pieDiabeValue === 'No') {
      newData.evaPDRange = 'bad-range'
      this.setState({ data: newData })
    } else {
      newData.evaPDRange = 'good-range'
      this.setState({ data: newData })
    }

    console.log('genero ', this.state.data.patientData.genero, ' edad ', this.state.data.patientAge, ' reserva ', this.state.data.fx_reserve)

    if (this.state.data.patientData.genero === 'f') {
      if (this.state.data.patientAge < 45) {
        if (this.state.data.fx_reserve >= 80) {
          newData.resFnRange = 'good-range'
          this.setState({ data: newData })
        } else if ((this.state.data.fx_reserve < 80) && (this.state.data.fx_reserve >= 60)) {
          newData.resFnRange = 'regular-range'
          this.setState({ data: newData })
        } else if (this.state.data.fx_reserve < 60) {
          newData.resFnRange = 'bad-range'
          this.setState({ data: newData })
        }
      } else if ((this.state.data.patientAge > 45) && (this.state.data.patientAge < 65)) {
        if (this.state.data.fx_reserve >= 75) {
          newData.resFnRange = 'good-range'
          this.setState({ data: newData })
        } else if ((this.state.data.fx_reserve < 75) && (this.state.data.fx_reserve >= 50)) {
          newData.resFnRange = 'regular-range'
          this.setState({ data: newData })
        } else if (this.state.data.fx_reserve < 50) {
          newData.resFnRange = 'bad-range'
          this.setState({ data: newData })
        }
      } else if (this.state.data.patientAge >= 65) {
        if (this.state.data.fx_reserve >= 65) {
          newData.evaPDRange = 'good-range'
          this.setState({ data: newData })
        } else if ((this.state.data.fx_reserve < 65) && (this.state.data.fx_reserve >= 40)) {
          newData.resFnRange = 'regular-range'
          this.setState({ data: newData })
        } else if (this.state.data.fx_reserve < 40) {
          newData.resFnRange = 'bad-range'
          this.setState({ data: newData })
        }
      }
    }

    if (this.state.data.patientData.genero === 'm') {
      if (this.state.data.patientAge < 40) {
        if (this.state.data.fx_reserve >= 82) {
          newData.resFnRange = 'good-range'
          this.setState({ data: newData })
        } else if ((this.state.data.fx_reserve < 82) && (this.state.data.fx_reserve >= 60)) {
          newData.resFnRange = 'regular-range'
          this.setState({ data: newData })
        } else if (this.state.data.fx_reserve < 60) {
          newData.resFnRange = 'bad-range'
          this.setState({ data: newData })
        }
      } else if ((this.state.data.patientAge > 40) && (this.state.data.patientAge <= 60)) {
        if (this.state.data.fx_reserve >= 75) {
          newData.resFnRange = 'good-range'
          this.setState({ data: newData })
        } else if ((this.state.data.fx_reserve < 75) && (this.state.data.fx_reserve >= 50)) {
          newData.resFnRange = 'regular-range'
          this.setState({ data: newData })
        } else if (this.state.data.fx_reserve < 50) {
          newData.resFnRange = 'bad-range'
          this.setState({ data: newData })
        }
      } else if (this.state.data.patientAge > 60) {
        if (this.state.data.fx_reserve >= 72) {
          newData.resFnRange = 'good-range'
          this.setState({ data: newData })
        } else if ((this.state.data.fx_reserve < 72) && (this.state.data.fx_reserve >= 40)) {
          newData.resFnRange = 'regular-range'
          this.setState({ data: newData })
        } else if (this.state.data.fx_reserve < 40) {
          newData.resFnRange = 'bad-range'
          this.setState({ data: newData })
        }
      }
    }
    // nuevo requisito
    if(this.state.data.medicalData.tiempoCincoM <= 6) {
      newData.tiempo = 'good-range'
      this.setState({ data: newData })
    } else {
      newData.tiempo = 'bad-range'
      this.setState({ data: newData })
    }
    if( this.state.data.diabetesCalc.RiesgoPromAñoComplic < 15 ){
      newData.complicacion = 'good-range'
      this.setState({ data: newData })
    } else if(this.state.data.diabetesCalc.RiesgoPromAñoComplic >= 15 && this.state.data.diabetesCalc.RiesgoPromAñoComplic < 30){
      newData.complicacion = 'regular-range'
      this.setState({ data: newData })
    } else {
      newData.complicacion = 'bad-range'
      this.setState({ data: newData })
    }

  }

  medicalCalculate () {
    let mdata = this.state.data.medicalData
    let pdata = this.state.data.patientData

    let healthRate = (mdata.frecuencia < 30) ? 30 : (mdata.frecuencia > 90) ? 90 : mdata.frecuencia
    let timeFiveMe = mdata.tiempoCincoM
    let ArrayBalance =  [mdata.balanceNeuroMuscularIzquierdo, mdata.balanceNeuroMuscularDerecho]
    let balanceNeu = ArrayBalance.reduce((max, val) =>{ return Math.max(max,val)},ArrayBalance[0])
    balanceNeu = (balanceNeu < 10) ? 10 : (balanceNeu > 42) ? 42 : balanceNeu
    let cardioResp = mdata.mets
    let transcendence = mdata.depresion
    let satisfaccion = mdata.satisfaccion
    let felicidad = mdata.feliz
    let preocupado = mdata.preocupacion
    let depresion = mdata.decaido
    let gender = pdata.genero
    let peso = (mdata.peso < 50) ? 50 : (mdata.peso > 110) ? 110 : mdata.peso
    let altura = mdata.altura
    let birthday = moment(pdata.fechaNacimiento).format('DD/MM/YYYY')
    let smoke = mdata.fuma
    let movility = mdata.movilidad
    let personalCare = mdata.cuidadoPersonal
    let dActivities = mdata.actividadesCotidianas
    let patientPain = mdata.dolor
    let anxiety = mdata.ansiedad

    let calculos = calculate(healthRate, timeFiveMe, balanceNeu, cardioResp, transcendence, satisfaccion, felicidad, preocupado, depresion,
     gender, peso, altura, birthday, smoke, movility, personalCare, dActivities, patientPain, anxiety)

    var newData = this.state.data
    newData.vitalityIndex = calculos[2]
    newData.percent_lost_capacity = calculos[4]
    newData.fx_reserve = calculos[5]
    newData.arterialAge = calculos[6]
    newData.biologicalAge =calculos[7]
    newData.functionalIndex = calculos[8]
    newData.balanceAfectivo = calculos[1][3] * 10
    console.log(calculos)
    this.setState({ data: newData })
  }

  vlookup (index, table) {
    for (var i = 0, l = table[0].length; i < l; i++) {
      if (index === table[0][i]) return table[1][i]
      if (i < l - 1) {
        if (index > table[0][i] && index < table[0][i + 1]) return table[1][i]
      }
      if (i === l) return table[1][l]
    }
  }

  findDiabetes () {
    let identificacion = this.props.params.patient
    request
      .get('api/v1/diabetes/findDiabetesByIdOne/')
      .query({ id: identificacion })
      .set('Authorization', 'Bearer ' + getToken())
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err || !res.ok) {
          console.log('Error: ', err)
        } else if (!_.isEmpty(res.body)) {
          let diabetesInfo = res.body
          var newData = this.state.data
          newData.diabetesData = diabetesInfo
          newData.albuminuria = (newData.diabetesData.albuminuria === null) ? '' : (newData.diabetesData.albuminuria === true) ? 0 : 1

          this.setState({ data: newData })
        } else {
          console.log('Error: ', err)
        }
        this.diabetesCalculate()
      })
  }

  diabetesCalculate () {
    let identificacion = this.props.params.patient
    request
    .get('api/v1/diabetes/diabetes/')
    .query({ id: identificacion })
    .set('Authorization', 'Bearer ' + getToken())
    .set('Accept', 'application/json')
    .end((err, res) => {
      if (err) {
        console.log(err)
      }
      if (res.body) {
        let diabetes = res.body
        var newData = this.state.data
        newData.diabetesCalc = diabetes

        this.setState({
          data: newData
        })
        this.checkRangesClass()
      }
    })
  }

  printReport (e) {
    e.preventDefault()
    window.print()
  }

  render () {
    document.title = 'Dashboard Paciente - CORE 3.0'
    let fechaControl = moment(this.state.data.medicalData.timestamp, 'x').format('DD/MM/YYYY')

    return (
      <div className='dashboard-container-printable'>
        <div className='navigation-bar-printable'>
          <div className='printable-data-diabetes'>
            <div className='navigation-conatiner printable-data-diabetes-img '>
              <img className='nav-logo-container' src={SicorLogoColor} />
            </div>
            <div className='printable-data-diabtes-title'>
              <h1>{this.state.reportTitle}</h1>
            </div>
          </div>
        </div>
        <hr/>
          <PatientData data={this.state.data}/>
        <hr/>
        <div className='dashboard-charts-components-printable'>
          <div className='Control'> <span className='data-title'>Control </span> {this.state.data.medicalData.control} </div>
          <div className='Control'> <span className='data-title'>Fecha Control </span> {fechaControl} </div>
          <div className='report-data-column-d'>
            <div className='chart-section-printable diabetes-col-report-'>
              <MedicalData data={this.state.data}/>
            </div>

            <div className='chart-section-printable diabetes-col-report-'>
              <DiabetesData data={this.state.data}/>
            </div>
            
          </div>
          <div className='chart-section-printable db-button'>
            <div ref='print-button' className='print-button' onClick={this.printReport.bind(this)}>Imprimir Reporte</div>
          </div>
        </div>
      </div>
    )
  }
}

/* Validate Props */
PrintableDiabetes.propTypes = {
  params: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/PrintableDiabetes/PrintableDiabetes.js